// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3wjAQ","productName":"Table_productName__kpApl"};